import React from 'react';

import classNames from 'classnames';

import './styles.scss';

interface Props {
  checked: boolean;
  disabled?: boolean;
  label: string;
  subtext: string;
  onClick: () => void;
}

export default function RadioInput({ checked, disabled, label, subtext, onClick }: Props) {
  const inputClasses = 'd-flex flex-row ds-border ds-border-light ds-rounded px-3 py-4 import-settings-input';

  return (
    <div
      className={classNames(inputClasses, { clickable: !disabled, selected: checked, disabled })}
      onClick={disabled ? undefined : onClick}
    >
      <input
        checked={checked}
        className="import-setting-radio-button mt-0 mx-2"
        disabled={disabled}
        type="radio"
      />
      <div className="d-flex flex-column grow-1 ml-3">
        <b>{label}</b>
        <div>{subtext}</div>
      </div>
    </div>
  );
}